import React from "react";
import SearchBar from "../../../../components/SearchBar";

const SearchInput = ({ theme, isRTL, t, searchTerm, setSearchTerm, attendanceData }) => {
  return (
    <div>
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "8px",
          fontSize: "14px",
          fontWeight: "600",
          textAlign: isRTL ? "right" : "left",
        }}
      >
        {t.searchEmployee}
      </label>
      <SearchBar
        value={searchTerm}
        onChange={(value) => {
          setSearchTerm(value);
          console.log(`🔍 Searching for: "${value}"`);
          console.log(`📊 Available records: ${attendanceData.length}`);
        }}
        placeholder={t.typeEmployeeName}
        theme={theme}
        language={isRTL ? "ar" : "en"}
        icon={true}
      />
    </div>
  );
};

export default SearchInput;